export const favoriteFilterKeys = {
  approve_status: 'favKanbanApproveStatus',
  communication_statuses: 'favKanbanCommunicationStatuses',
  traffic_statuses: 'favKanbanTrafficStatuses',
  traffic_sources: 'favKanbanTrafficSources',
  traffic_geos: 'favKanbanTrafficGeos',
  affiliate_ids: 'favKanbanAffiliateIds',
  manager_ids: 'favKanbanManagerIds',
  manager_teams: 'favKanbanManagerTeams',
  platform_ids: 'favKanbanPlatformIds',
  invitation_link_ids: 'favKanbanInvitationLinksIds',
  invitation_manager_ids: 'favKanbanInvitationManagersIds',
  max_min_balance_amount: 'favKanbanMaxMinBalanceAmount',
  has_multi_account: 'favKanbanHasMultiAccount',
  tagIds: 'favKanbanTagIds',
  subAffLevels: 'favKanbanSubAffLevels',
  subAffDeals: 'favKanbanSubAffDeals',
  hasReferralProgram: 'favKanbanHasReferralProgram',
  parentAffiliateIds: 'favKanbanParentAffiliateIds',
  registrationDate: 'favKanbanRegistrationDate',
};

export interface IKanbanFilterData {
  [key: string]: any;
  communication_statuses: any[];
  traffic_statuses: any[];
  traffic_geos: any[];
  traffic_sources: any[];
  manager_teams: any[];
  manager_ids: any[];
  affiliate_ids: any[];
  approve_status: any;
  platform_ids: any[];
  invitation_link_ids: any[];
  invitation_manager_ids: any[];
  min_balance_amount: string;
  max_balance_amount: string;
  has_multi_account: any;
  tagIds: any[];
  subAffLevels: any[];
  subAffDeals: any[];
  hasReferralProgram: any;
  parentAffiliateIds: any[];
  registrationFrom: string;
  registrationTo: string;
}

export const initFilterState: IKanbanFilterData = {
  communication_statuses: [],
  traffic_statuses: [],
  traffic_geos: [],
  traffic_sources: [],
  manager_teams: [],
  manager_ids: [],
  affiliate_ids: [],
  approve_status: null,
  platform_ids: [],
  invitation_link_ids: [],
  invitation_manager_ids: [],
  min_balance_amount: '',
  max_balance_amount: '',
  has_multi_account: null,
  tagIds: [],
  subAffLevels: [],
  subAffDeals: [],
  hasReferralProgram: null,
  parentAffiliateIds: [],
  registrationFrom: '',
  registrationTo: '',
};

export const boardStorageProps = {
  type: 'crm-board',
  columnsSettingsTarget: 'columns-settings',
};
